import React from 'react';

const Footer = () => {
  	return <footer>&copy; - Created by Maria Alarcon💖</footer>
}

export default Footer;
